import * as type from '../constants/ActionTypes';

export default function clients(
  state = {
    isFetching: false,
    authenticated: false
  },
  action
) {

  switch (action.type) {
    case type.CLIENT_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case type.CLIENT_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        clientList: action.response,
      });
    case type.CLIENT_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}